import { Button, Checkbox, Form, message } from 'antd';
import {
  MandateLinkDataType,
  NachUserAndBankDataPayload,
  BankDetailsPayload,
  createNachMandateLink,
} from 'api/nach';
import { useContext, useEffect, useState } from 'react';
import { SourceConfigContext } from '../create/MandateLink';
import BankDetails from './BankDetails';
import { FormInstance } from 'antd/es/form/Form';

import styled from 'styled-components';
import Loading from 'features/nach/components/Loading';
import { useNavigate } from 'react-router-dom';
import { AutoPayDetails } from './AutoPayDetails';

type Props = {
  gridForm: FormInstance;
  // setSelectedAutopayTabValue: boolean;
  setSelectedAutopayTabValue: (value: boolean) => void;
  setSelectedEnachTabValue: (value: boolean) => void;
  selectedEnachTabValue?: boolean;
  selectedAutopayTabValue?: boolean;
};

const StyledCheckbox = styled(Checkbox)`
  font-size: 14px;
  padding: 5px 8px;
  background-color: #2c9897;
  color: white;
`;

function NachSelectionTabs({
  gridForm,
  setSelectedAutopayTabValue,
  // selectedAutopayTabValue,
  setSelectedEnachTabValue,
}: //selectedEnachTabValue,
  Props) {
  const {
    autoPay,
    setAutoPay,
    enach,
    setEnach,
    pnach,
    setPnach,
    // setFetchedData,
    checkedRecord,
    fetchedData,
    mandateAmount,
    isVisibleAutoPay,
    isVisibleEnach,
    isVisiblePnach,
    // setIsModalOpen,
    // isMandateCancel,
    maxBillAmount,
  } = useContext(SourceConfigContext);

  let mappedAutopay = fetchedData[0].autoPayLoanTypeEnable;
  console.log('mappedAutopay', mappedAutopay);

  console.log('isVisibleAutoPay', isVisibleAutoPay);

  const [sameAsEnach, setSameAsEnach] = useState(false);
  const [pnachBankData, setPnachBankData] = useState<any>();
  const [enachBankData, setEnachBankData] = useState<any>();
  const [autoPayBankData, setAutoBankData] = useState<any>();
  const [formPnach] = Form.useForm();
  const [formEnach] = Form.useForm();
  const [formAutoPay] = Form.useForm();
  const navigate = useNavigate();
  const [enachBankCode, setEnachBankCode] = useState<string | undefined>(undefined);
  const [pnachBankCode, setPnachBankCode] = useState<string | undefined>(undefined);

  const [autoPayBankCode, setAutoBankCode] = useState<string | undefined>(undefined);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    formEnach.resetFields();
    formPnach.resetFields();
    formAutoPay.resetFields();
    setEnach(false);
    setPnach(false);
    setAutoPay(false);
    setPnachBankData(undefined);
    setEnachBankData(undefined);
    setAutoBankData(undefined);
  }, [fetchedData, checkedRecord]);

  useEffect(() => {
    if (sameAsEnach) {
      setPnachBankData(enachBankData);
    }
  }, [sameAsEnach, enachBankData]);

  useEffect(() => {
    if (!enach) {
      setSameAsEnach(false);
    }
  }, [enach]);

  const handleGridForm = () => {
    return gridForm
      .validateFields()
      .then((values) => {
        console.log('Success:', values);
        return true;
      })
      .catch((info) => {
        message.error('Please fill Checked Field Details', 2);
        console.log('Validate Failed:', info);

        return false;
      });
  };
  console.log('pnch bank code pnachBankCode');

  const handleButtonClick = async () => {
    let checkedRecordValue;
    if (checkedRecord === 'input') {
      const valid = await handleGridForm();
      if (!valid) {
        return;
      }
      checkedRecordValue = gridForm.getFieldsValue();
    } else {
      checkedRecordValue = fetchedData?.find(
        (item: MandateLinkDataType) => item.id === checkedRecord
      );
    }
    console.log('selected GridFields Value', checkedRecordValue);
    const bankDetails: BankDetailsPayload[] = [];

    const enachFormData: BankDetailsPayload = formEnach.getFieldsValue();
    const pnachFormData: BankDetailsPayload = formPnach.getFieldsValue();
    const autoPayFormData: BankDetailsPayload = formAutoPay.getFieldsValue();
    if (enach && !enachFormData.isEditable) {
      let isReturn = false;
      await formEnach.validateFields().catch(() => {
        isReturn = true;
      });
      console.log('enach validation ', enachBankData);
      if (isReturn) {
        return;
      }
    }
    if (autoPay && !autoPayFormData.isEditable) {
      let isReturn = false;
      await formAutoPay.validateFields().catch(() => {
        isReturn = true;
      });
      console.log('enach validation ', enachBankData);
      if (isReturn) {
        return;
      }
    }
    if (pnach && !pnachFormData.isEditable) {
      let isReturn = false;
      await formPnach.validateFields().catch(() => {
        isReturn = true;
      });

      console.log('panch validation ', pnachBankData);
      if (isReturn) {
        return;
      }
    }
    console.log('fetched data', fetchedData);

    enach &&
      bankDetails.push({
        nachtype: 1,
        accountNo: enachFormData?.accountNo,
        bankName: enachFormData?.bankName,
        accountType: enachFormData?.accountType,
        branchName: enachFormData?.branchName,
        ifscCode: enachFormData?.ifscCode,
        isEditable: enachFormData?.isEditable,
        accountHolderName: enachFormData?.accountHolderName,
        bankCode: enachBankCode,
      });
    pnach &&
      bankDetails.push({
        nachtype: 2,
        accountNo: pnachFormData?.accountNo,
        bankName: pnachFormData?.bankName,
        accountType: pnachFormData?.accountType,
        branchName: pnachFormData?.branchName,
        ifscCode: pnachFormData?.ifscCode,
        isEditable: pnachFormData?.isEditable,
        accountHolderName: pnachFormData?.accountHolderName,
        bankCode: pnachBankCode,
      });

    if (autoPay) {
      bankDetails.push({
        nachtype: 0,
        accountNo: autoPayFormData?.accountNo,
        bankName: autoPayFormData?.bankName,
        // accountType: autoPayFormData?.accountType,
        branchName: autoPayFormData?.branchName,
        ifscCode: autoPayFormData?.ifscCode,
        isEditable: autoPayFormData?.isEditable,
        accountHolderName: autoPayFormData?.accountHolderName,
        bankCode: autoPayBankCode,
      });
    }

    // const getNachId = () => {
    //   if (enach && pnach) return 3;
    //   if (enach) return 1;
    //   if (pnach) return 2;
    //   return 0;
    // };

    const userId = sessionStorage.getItem('userId');
    let finalMandateAmount = mandateAmount;

    if (autoPay && !enach && !pnach) {
      // The display logic already checks that mandateAmount is <= 15000, so we can
      // safely use the existing value or default to a safe value like 0.
      // Let's use the mandateAmount value directly.
      finalMandateAmount = mandateAmount;
    }

    const requestData: NachUserAndBankDataPayload = {
      lanNum: fetchedData[0].loanNo,
      cif: fetchedData[0].cIFId,
      loanAmount: fetchedData[0].loanAmount / 100,
      mandateAmount: finalMandateAmount, // Use the corrected mandateAmount
      maxBillingAmount: maxBillAmount,
      tenure: fetchedData[0].loanTenor,
      sourceId: sessionStorage.getItem('sourceId') || '',
      userDetails: {
        email_id: checkedRecordValue?.emailId,
        mobileNum: checkedRecordValue?.mobileNumber,
        relationship: checkedRecordValue?.accountName,
        username: checkedRecordValue?.customerName,
      },
      createdBy: parseInt(userId || '0'),
      vpa: '',
      loantype: fetchedData[0].loanType,
      isAutopay: autoPay,
      bankDetails: [...bankDetails],
      nachId: 1,
      isApi: true,
    };

    setIsLoading(true);
    createNachMandateLink(requestData)
      .then((res) => {
        console.log('mandate link', res);
        if (res.status == 'SUCCESS') {
          message.success('Link successfully created', 1).then(() => {
            navigate(0);
          });
        } else {
          // Add a check for a non-success status and show an error message.
          // This will help in debugging API failures.
          message.error('Failed to Generate Link: ' + res.message);
        }
      })
      .catch((error) => {
        console.error('API Error:', error);
        message.error('Failed to Generate Link. An error occurred.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Loading isLoading={isLoading} />
      <div style={{ marginTop: '20px' }}>
        <div style={{ display: 'flex', gap: '10px', marginLeft: '15px' }}>
          {isVisibleEnach ? (
            <StyledCheckbox
              checked={enach}
              onClick={(e: any) => {
                setEnach(e.target.checked);
                setSelectedEnachTabValue(e.target.checked);
              }}
            >
              E-NACH
            </StyledCheckbox>
          ) : null}
          {isVisiblePnach ? (
            <StyledCheckbox checked={pnach} onClick={(e: any) => setPnach(e.target.checked)}>
              P-NACH
            </StyledCheckbox>
          ) : null}
          {mandateAmount > 0 &&
            mandateAmount <= 15000 &&
            // maxBillAmount > 0 &&
            // maxBillAmount <= 15000 &&
            isVisibleAutoPay ? (
            fetchedData[0].autoPayLoanTypeEnable ? (
              <StyledCheckbox
                checked={autoPay}
                onClick={(e: any) => {
                  setAutoPay(e.target.checked);
                  setSelectedAutopayTabValue(e.target.checked);
                }}
              >
                Auto Pay
              </StyledCheckbox>
            ) : null
          ) : null}
          {!fetchedData[0].autoPayLoanTypeEnable && isVisibleAutoPay ? (
            <div style={{ color: 'red', fontSize: '15px', fontWeight: 'bold', paddingTop: '5px' }}>
              Note : Loan type mapping is not available for the AutoPay
            </div>
          ) : (
            ''
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {enach && (
            <div style={{ marginTop: '10px' }}>
              <BankDetails
                fetchedData={fetchedData}
                checkedRecord={checkedRecord}
                nachId={1}
                mandateAmount={mandateAmount}
                nachBankData={enachBankData}
                setNachBankData={setEnachBankData}
                title="E-NACH Bank Details"
                form={formEnach}
                setBankCode={setEnachBankCode}
              />
            </div>
          )}
          {autoPay && (
            <div style={{ marginTop: '10px' }}>
              <AutoPayDetails
                fetchedData={fetchedData}
                checkedRecord={checkedRecord}
                nachId={1}
                isVisibleEnach={enach}
                mandateAmount={mandateAmount}
                nachBankData={autoPayBankData}
                //  setNachBankData={setEnachBankData}
                setNachBankData={setAutoBankData}
                title="AutoPay Bank Details"
                form={formAutoPay}
                enachBankData={enachBankData}
                setBankCode={setAutoBankCode}
              />
            </div>
          )}
          <div>
            {enach && pnach ? (
              <div style={{ display: 'flex', gap: '10px', margin: '10px' }}>
                <StyledCheckbox
                  checked={sameAsEnach}
                  onClick={(e: any) => setSameAsEnach(e.target.checked)}
                >
                  Same As Enach
                </StyledCheckbox>
              </div>
            ) : null}
          </div>
          {pnach && (
            <div style={{ marginTop: '10px' }}>
              <BankDetails
                nachId={2}
                fetchedData={fetchedData}
                checkedRecord={checkedRecord}
                mandateAmount={mandateAmount}
                nachBankData={pnachBankData}
                setNachBankData={setPnachBankData}
                title="P-NACH Bank Details"
                sameAsEnach={sameAsEnach}
                form={formPnach}
                setBankCode={setPnachBankCode}
              />
            </div>
          )}
        </div>
        {pnach || enach || autoPay ? (
          <div style={{ margin: '10px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="primary" size="middle" onClick={handleButtonClick}>
              Send Link
            </Button>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default NachSelectionTabs;
